<template>
	<v-container class="maxw-40">
		<v-card class="pa-5">
			<v-form @submit.prevent="submit">
				<v-text-field
					v-model="newPassword"
					label="Password"
					:type="passwordInputType"
					:append-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
					@click:append="showPasswords = !showPasswords"
				/>
				<v-text-field
					v-model="newPasswordConfirmation"
					label="Confirm Password"
					:type="passwordInputType"
					:append-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
					@click:append="showPasswords = !showPasswords"
				/>
				<div class="d-flex justify-end">
					<v-btn type="submit" color="primary">Set Password</v-btn>
				</div>
			</v-form>
		</v-card>
		<transition name="fade">
			<app-feedback v-if="status" class="mt-5" @closed="status = null" :type="status.type">{{
				status.message
			}}</app-feedback>
		</transition>
	</v-container>
</template>

<script>
import appFeedback from '@/components/common/Feedback.vue';
import soilApiService from '../../services/soilApiService';

export default {
	components: {
		appFeedback,
	},
	data() {
		return {
			token: '',
			status: null,
			showPasswords: false,
			newPassword: '',
			newPasswordConfirmation: '',
		};
	},
	computed: {
		passwordInputType() {
			return this.showPasswords ? 'text' : 'password';
		},
	},
	methods: {
		async submit() {
			this.status = null;

			if (this.newPassword.trim() === '') {
				this.status = {
					type: 'error',
					message: 'You must enter a password.',
				};
				return;
			}

			if (this.newPassword !== this.newPasswordConfirmation) {
				this.status = {
					type: 'error',
					message: 'Passwords do not match.',
				};
				return;
			}

			try {
				await soilApiService.resetPassword({ passwordResetToken: this.token, password: this.newPassword });

				this.$router.push('/');
			} catch (error) {
				this.status = {
					type: 'error',
					message: 'An error has occurred. Please try again.',
				};
			}
		},
	},
	created() {
		this.token = this.$route.query?.token;
	},
};
</script>
